/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { userControllerGetMe } from '../fn/user/user-controller-get-me';
import { UserControllerGetMe$Params } from '../fn/user/user-controller-get-me';
import { userControllerUpdateMe } from '../fn/user/user-controller-update-me';
import { UserControllerUpdateMe$Params } from '../fn/user/user-controller-update-me';
import { UserModelDto } from '../models/user-model-dto';

@Injectable({ providedIn: 'root' })
export class UserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `userControllerGetMe()` */
  static readonly UserControllerGetMePath = '/user/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerGetMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe$Response(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return userControllerGetMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerGetMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerGetMe(params?: UserControllerGetMe$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.userControllerGetMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

  /** Path part for operation `userControllerUpdateMe()` */
  static readonly UserControllerUpdateMePath = '/user/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userControllerUpdateMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUpdateMe$Response(params: UserControllerUpdateMe$Params, context?: HttpContext): Observable<StrictHttpResponse<UserModelDto>> {
    return userControllerUpdateMe(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `userControllerUpdateMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userControllerUpdateMe(params: UserControllerUpdateMe$Params, context?: HttpContext): Observable<UserModelDto> {
    return this.userControllerUpdateMe$Response(params, context).pipe(
      map((r: StrictHttpResponse<UserModelDto>): UserModelDto => r.body)
    );
  }

}
